// Quick-add for the cart-drawer "Complete the look" upsell.
// Adds the variant, then re-renders the drawer inner + cart bubble from the
// Section Rendering API response (no full page reload).
document.addEventListener('click', async function (event) {
  const btn = event.target.closest('[data-pm-upsell-add]');
  if (!btn) return;
  event.preventDefault();

  const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
  const original = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding…';

  try {
    const res = await fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    });
    const data = await res.json();

    if (data.status) {
      // Shopify error (e.g. sold out)
      btn.disabled = false;
      btn.textContent = original;
      return;
    }

    const sections = data.sections || {};

    // Replace the drawer inner
    if (sections['cart-drawer']) {
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const newInner = doc.querySelector('.drawer__inner');
      const curInner = document.querySelector('cart-drawer .drawer__inner');
      if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
    }

    // Update the cart icon bubble
    if (sections['cart-icon-bubble']) {
      const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const newBubble = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
      const curBubble = document.querySelector('#cart-icon-bubble');
      if (newBubble && curBubble) curBubble.innerHTML = newBubble.innerHTML;
    }

    // Open the drawer
    const cd = document.querySelector('cart-drawer');
    if (cd) {
      if (typeof cd.open === 'function') {
        cd.open();
      } else {
        cd.classList.add('active', 'animate');
        document.body.classList.add('overflow-hidden');
      }
    }
  } catch (err) {
    btn.disabled = false;
    btn.textContent = original;
  }
});
